export default __webpack_public_path__ + "f86a814cde70c1da77d0d862b91870f1.png";